import React from 'react';
import { Checkbox, Icon } from 'antd'
import { AppFormPageProps, AppGridBar, AppGridTabs, AppButton, AppRow, AppAction as MyAction } from 'qcc'
import api, { AppSystem, AppModule, AppModuleGroup, AppAction } from 'api'

const tabTextList = (systemList: AppSystem[]) => {
  return systemList.map((sys: AppSystem) => {
    return sys.name;
  })
}

interface GroupGrid {
  fullCode?: string
  name?: string
  checked?: boolean
  indeterminate?: boolean
  childrenHidden?: boolean
  moduleGridList?: ModuleGrid[]
}

interface ModuleGrid {
  fullCode?: string
  parentCode?: string
  name?: string
  actionList?: ActionGrid[]
  checked?: boolean
  indeterminate?: boolean
  childrenHidden?: boolean
}

interface ActionGrid {
  actionCode?: string
  actionName?: string
  checked?: boolean
}



export default class AuthorizeForm extends React.PureComponent<AppFormPageProps> {
  state = {
    tabIndex: 0,
    systemList: [] as AppSystem[],
    gridList: [] as GroupGrid[],
    actionCodeList: [] as string[],
    checked: false,
    indeterminate: false,
    changFlag: false
  }

  async componentDidMount() {
    this.tabChg(this.state.tabIndex);
  }


  handleTreeGridData = (groupList: AppModuleGroup[], moduleList: AppModule[], actionCodeList: string[]) => {
    let moduleGrid = this.handleModuleData(moduleList, actionCodeList);
    return groupList.map((group: AppModuleGroup) => {
      let { fullCode, name } = group;
      let moduleGridList = moduleGrid.filter(e => e.parentCode === fullCode);
      let unCheckCount = moduleGridList.filter(e => !e.checked).length;
      let count = moduleGridList.length;
      let checked = unCheckCount === 0
      let indeterminate = unCheckCount > 0 && (count - unCheckCount) > 0
      let childrenHidden = false;
      return { fullCode, name, checked, indeterminate, childrenHidden, moduleGridList } as GroupGrid
    })
  }

  handleModuleData = (moduleList: AppModule[], actionCodeList: string[]) => {
    return moduleList.map((module: AppModule) => {
      let { fullCode, parentCode, name } = module;
      let actionList: ActionGrid[] = module.appActionList.map((action: AppAction) => {
        let actionCode = action.actionCode;
        let actionName = action.name;
        let actionChecked = actionCodeList.filter(e => e === actionCode).length > 0;
        return { actionCode, actionName, checked: actionChecked } as ActionGrid;
      })
      let unCheckCount = actionList.filter(e => !e.checked).length;
      let count = actionList.length;
      let moduleChecked = unCheckCount === 0
      let moduleIndeterminate = unCheckCount > 0 && (count - unCheckCount) > 0
      return { fullCode, parentCode, name, actionList, checked: moduleChecked, indeterminate: moduleIndeterminate, childrenHidden: false } as ModuleGrid;
    })
  }

  befTabChg = () => {
    if (this.state.changFlag && !confirm('请确定当前页面授权是否已经保存！')) {
      return false
    }
    return true
  }

  tabChg = async (tabIndex: number) => {

    let { formData } = this.props
    let systemList = await api.modeling.module.getSystemList();
    let systemCode = systemList[tabIndex].code;
    let groupList = await api.modeling.module.getAllGroupList({ systemCode });
    let moduleList = await api.modeling.module.getAllModuleList({ systemCode });
    let actionCodeList = await api.role.getRoleActionCodeList({ id: formData.id || 0 });
    let gridList = this.handleTreeGridData(groupList, moduleList, actionCodeList);
    let allCheckStatus = this.getAllCheckStatus(gridList);
    let checked = allCheckStatus === 1
    let indeterminate = allCheckStatus === 2
    this.setState({ tabIndex, systemList, gridList, actionCodeList, checked, indeterminate, changFlag: false });
    this.setState({ tabIndex })
  }

  getAllCheckStatus = (gridList?: any[]) => {
    let count = gridList.length;
    let unCheckCount = gridList.filter(e => !e.checked).length;
    if ((count - unCheckCount) === 0) return 0
    if (unCheckCount === 0) return 1
    return 2
  }


  handleAllcheck = (checked?: boolean) => {
    let { gridList } = this.state;
    gridList.map((group: GroupGrid) => {
      group.checked = checked;
      group.indeterminate = false;
      group.moduleGridList.map((module: ModuleGrid) => {
        module.checked = checked;
        module.indeterminate = false;
        module.actionList.map((action: ActionGrid) => {
          action.checked = checked;
        })
      })
    })
    this.setState({ gridList, checked, indeterminate: false, changFlag: true })
  }

  handleGroupCheck = (fullCode: string, checked?: boolean) => {
    let { gridList } = this.state;
    gridList.map((group: GroupGrid) => {
      if (group.fullCode === fullCode) {
        group.moduleGridList.map((moduleGrid: ModuleGrid) => {
          moduleGrid.actionList.map((action: ActionGrid) => {
            action.checked = checked;
          })
        })
      }
    })
    this.afterHandleCheck([...gridList]);
  }

  handleModuleCheck = (fullCode: string, checked?: boolean) => {
    let { gridList } = this.state;
    gridList.map((group: GroupGrid) => {
      group.moduleGridList.map((moduleGrid: ModuleGrid) => {
        if (moduleGrid.fullCode === fullCode) {
          moduleGrid.actionList.map((action: ActionGrid) => {
            action.checked = checked;
          })
        }

      })
    })
    this.afterHandleCheck([...gridList]);
  }


  handleChecked = (actionCode?: string, checked?: boolean) => {
    let { gridList } = this.state;
    gridList.map((group: GroupGrid) => {
      group.moduleGridList.map((module: ModuleGrid) => {
        module.actionList.map((action: ActionGrid) => {
          if (actionCode === action.actionCode) {
            action.checked = checked;
          }
        })
      })
    })

    this.afterHandleCheck([...gridList]);
  }

  afterHandleCheck = (gridList?: GroupGrid[]) => {
    // 处理module
    gridList.map((group: GroupGrid) => {
      group.moduleGridList.map((moduleGrid: ModuleGrid) => {
        let checkStatus = this.getAllCheckStatus(moduleGrid.actionList);
        moduleGrid.checked = checkStatus === 1
        moduleGrid.indeterminate = checkStatus === 2
      })
    })

    // 处理group
    gridList.map((group: GroupGrid) => {
      let checkStatus = this.getAllCheckStatus(group.moduleGridList);
      group.checked = checkStatus === 1
      group.indeterminate = checkStatus === 2
    })

    let allCheckStatus = this.getAllCheckStatus(gridList);
    let checked = allCheckStatus === 1
    let indeterminate = allCheckStatus === 2

    this.setState({ gridList, checked, indeterminate, changFlag: true })
  }

  getActionCodeList = () => {
    let { actionCodeList, gridList } = this.state;
    gridList.map((group: GroupGrid) => {
      group.moduleGridList.map((module: ModuleGrid) => {
        module.actionList.map((action: ActionGrid) => {
          if (action.checked && actionCodeList.filter(e => e === action.actionCode).length === 0) {
            actionCodeList.push(action.actionCode);
          }
          if (!action.checked && actionCodeList.filter(e => e === action.actionCode).length > 0) {
            actionCodeList = actionCodeList.filter(e => e !== action.actionCode)
          }
        })
      })
    })

    return actionCodeList;
  }

  save = async () => {
    let roleId = this.props.formData.id;
    let actionCodeList = this.getActionCodeList();
    let res = api.role.authorizeActions({ roleId, actionCodeList });
    MyAction.successMsg('操作成功！')
    this.tabChg(this.state.tabIndex);
  }


  renderModule = (data: ModuleGrid) => {
    let { childrenHidden, indeterminate, checked } = data;
    return (
      <div key={data.fullCode}>
        <div className='page-role-authorize-row'>
          <span className='page-role-authorize-module-icon'><Icon type={childrenHidden ? 'caret-right' : 'caret-down'} /></span>
          <span className='page-role-authorize-module-text'>{data.name}</span>
          <span><Checkbox checked={checked} onChange={(e) => { this.handleModuleCheck(data.fullCode, e.target.checked) }}
            indeterminate={indeterminate}>全选</Checkbox></span>
        </div>
        <div className='page-role-authorize-row' style={{ paddingLeft: 80 }}>
          {data.actionList.map((action: ActionGrid) => {
            return <span className='page-role-authorize-action-span' key={action.actionCode}>
              <Checkbox onChange={(e) => { this.handleChecked(action.actionCode, e.target.checked) }}
                checked={action.checked}>{action.actionName}</Checkbox>
            </span>
          })}
        </div>
      </div>
    )
  }


  renderGrid = () => {
    let { gridList } = this.state;

    return gridList.map((data: GroupGrid, index: number) => {
      let { childrenHidden, indeterminate, checked } = data;
      return <div key={index}>
        <div className='page-role-authorize-row'>
          <span className='page-role-authorize-group-icon'><Icon type={childrenHidden ? 'caret-right' : 'caret-down'} /></span>
          <span className='page-role-authorize-group-text'>{data.name}</span>
          <span><Checkbox onChange={(e) => { this.handleGroupCheck(data.fullCode, e.target.checked) }}
            checked={checked} indeterminate={indeterminate}>全选</Checkbox></span>
        </div>
        {data.moduleGridList.map(this.renderModule)}
      </div>
    })
  }

  refAppGridTabs = React.createRef<AppGridTabs>()
  render() {
    let { formData } = this.props;
    let { systemList, tabIndex, checked, indeterminate } = this.state;
    let currSystem = systemList.length === 0 ? { name: '' } : systemList[tabIndex];
    let tabDataList = tabTextList(systemList);
    return (<div className='page-role-authorize-container'><div className='page-role-authorize-inner'>
      <div className='page-role-authorize-header'>
        <AppRow>
          <label>角色名称</label>
          <span>{formData.name}</span>
        </AppRow>
      </div>
      <div className='page-role-authorize-mune'>
        <AppGridBar>
          <AppGridBar.Left>
            <AppGridTabs ref={this.refAppGridTabs} defaultTabIndex={0} tabs={tabDataList} befChange={this.befTabChg} onChange={this.tabChg} />
          </AppGridBar.Left>
          <AppGridBar.Right>
            <AppButton label='保存' type='primary' action={this.save} />
          </AppGridBar.Right>
        </AppGridBar>
      </div>
      <div className='page-role-authorize-content'>
        <div className='page-role-authorize-content-inner'>
          <div className='page-role-authorize-row'>
            <span className='page-role-authorize-system-text'>{currSystem.name}</span>
            <span><Checkbox onChange={(e) => { this.handleAllcheck(e.target.checked) }}
              checked={checked} indeterminate={indeterminate}>全选</Checkbox></span>
          </div>
          {this.renderGrid()}
          <div className='page-role-authorize-line'></div>
        </div>
      </div>
    </div></div>)
  }

}


// WEBPACK FOOTER //
// ./src/page/application/role/AuthorizeForm.tsx